﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateVehicles = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const StatePaged_1 = require("../abstracts/StatePaged");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_1 = require("@ivanlog/gs");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateVehicle_1 = require("./StateVehicle");
class StateVehicles extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageList, "Vehicles", true);
        this._callbackOnSelect = null;
        this.page.ctrls.blockSearch.show();
        this.page.ctrls.btnNew.onclick = () => gs_1.StateGS.Run(StateVehicle_1.StateVehicle);
        this.page.ctrls.btnSearch.onclick = () => this.trySearch();
        this.page.ctrls.taSearch.el.placeholder = "Search vehicles";
        if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.CompanyControl))
            this.page.ctrls.btnNew.hide();
    }
    static SelectVehicle() {
        return new Promise((resolve, reject) => {
            gs_1.StateGS.Run(StateVehicles, { callbackOnSelect: resolve });
        });
    }
    start(arg) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (arg) {
                if (arg.search) {
                    this.page.ctrls.taSearch.value = arg.search;
                    yield this.trySearch();
                    return _super.start.call(this);
                }
                this._callbackOnSelect = arg.callbackOnSelect;
                if (this._callbackOnSelect)
                    this.title = "Select vehicle:";
            }
            const vehicles = yield this.lockgui(this.app.api.admin.directory.getVehicles(0));
            if (!vehicles)
                return gs_1.StateRunResultEnum.Failed;
            yield this.fill(vehicles);
            return _super.start.call(this);
        });
    }
    fill(vehicles) {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.list.html = '';
            for (const vehicle of vehicles) {
                const vt = yield this.app.astra.getVehiclesType(vehicle.vehicleTypeId);
                const item = new com.ListItem();
                item.ctrls.lType.text = "Vehicle";
                item.ctrls.lId.text = `#${vehicle.id}`;
                let data = [gs.text.clearHtmlToText(`Type: ${vt.name}`),
                    gs.text.clearHtmlToText(`Model: ${vehicle.model}`),
                    gs.text.clearHtmlToText(`Gov.number: ${vehicle.govNumber}`),
                ];
                item.ctrls.pData.html = data.join('<br>');
                this.page.ctrls.list.append(item);
                if (this._callbackOnSelect)
                    item.onclick = () => this._callbackOnSelect(vehicle);
                else if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.VehicleControl))
                    item.onclick = () => gs_1.StateGS.Run(StateVehicle_1.StateVehicle, vehicle);
                else
                    item.onclick = () => new modalCom.DialogOk(gs.helpers.text.replaceAll(vehicle.vehicleData, '\n', '<br>'), "Vehicle information").show();
            }
        });
    }
    trySearch() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = this.page.ctrls.taSearch.value;
            if (!data)
                return;
            const vehicles = yield this.lockgui(this.app.api.admin.directory.searchVehicles(data));
            if (!vehicles)
                return;
            this.fill(vehicles);
            this._urlArgs["search"] = decodeURI(data);
            this.updateUrl();
        });
    }
}
exports.StateVehicles = StateVehicles;
StateVehicles.StateName = "vehicles";
//# sourceMappingURL=StateVehicles.js.map